import { createUsePromotion, getPreviewFromUrlOrSessionStorage, withPrefix } from '@insify/funnel-components';

import { isProd } from '../../util/env';

import { useCommands } from './useCommands';

const promotionName = withPrefix({
  prefix: 'insify-',
  value: window.insify_runtime_config.FRONTEND_FUNNEL_PARTNER,
});

// Todo add content (no design yet)
type Content = {
  title: string;
};

const { usePromotion, PromotionProvider: BaseProvider } = createUsePromotion<typeof promotionName, Content>({
  isPreviewAvailable: !isProd,
  name: promotionName,
});

const PromotionProvider: React.FC<{ children: React.ReactNode }> = (props) => {
  const { sendCommand } = useCommands();
  return (
    <BaseProvider
      // We use the same logic for promotion as for partner on the BE
      onMountPromotion={(promotionName) =>
        sendCommand({
          type: 'usePartner',
          payload: {
            partner: promotionName,
          },
        })
      }
      allContent={{
        'insify-comparadise': {
          title: 'Comparadise title to be used within the promotion',
        },
      }}
    >
      {props.children}
    </BaseProvider>
  );
};

const getPromotionName = () =>
  getPreviewFromUrlOrSessionStorage({ isEnabled: !isProd, queryKey: 'promotion' })[1] ?? promotionName;

export const isPromotionComparadise = () => {
  return getPromotionName() === 'insify-comparadise';
};

export { usePromotion, PromotionProvider };
